import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
import { Form, Alert, message } from "antd";

// search provider

const SearchProvider = (props) => {
  const api = new API();
  const [seoData, setSeoData] = useState([]);
  const [searchLoader, setSearchLoader] = useState(false);
  const [searchLoaderDropdown, setSearchLoaderDropdown] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [searchTable, setSearchTable] = useState({
    clinic_id: "",
    clinic_slug: "",
    province_id: "",
    secretariats_id: "",
    district: "",
    pincode: "",
    id: "",
    search: "",
    page: 1,
    limit: 5,
  });
  // console.log("searchData", searchData);
  // area filter
  const [areaFilterLoader, setAreaFilterLoader] = useState(false);
  const [areaFilterData, setAreaFilterData] = useState([]);

  // appointment form
  const [addAppointmentPopup, setAddAppointmentPopup] = useState(false);
  const [addAppointmentFormLoader, setAddAppointmentFormLoader] =
    useState(false);
  const [clinicFormPopup, setClinicFormPopup] = useState(false);
  const [addAppointmentForm] = Form.useForm();
  const [selectedDropdown, setSelectedDropdown] = useState({
    province_id: "",
    district_id: "",
    secretariats_id: "",
  });
  // dropwdown province
  const [provinceListDropdown, setProvinceListDropdown] = useState([]);
  const [provinceLoaderDropdown, setProvinceLoaderDropdown] = useState(false);
  // dropwdown province
  const [districtListDropdown, setDistrictListDropdown] = useState([]);
  const [districtLoaderDropdown, setDistrictLoaderDropdown] = useState(false);
  // secratariate province
  const [secretariatListDropdown, setSecretariatListDropdown] = useState([]);
  const [secretariatLoaderDropdown, setSecretariatLoaderDropdown] =
    useState(false);
  // doctor list
  const [doctorSearchLoader, setDoctorSearchLoader] = useState(false);
  // const [searchLoaderDropdown, setSearchLoaderDropdown] = useState(false);
  const [doctorSearchData, setDoctorSearchData] = useState("");
  const [doctorSearchTable, setDoctorSearchTable] = useState({
    clinic_id: "",
    clinic_slug: "",
    province_id: "",
    secretariats_id: "",
    district: "",
    pincode: "",
    id: "",
    search: "",
    page: 1,
    limit: 10,
  });
  // pinpoint
  const [pincodeLoader, setPincodeLoader] = useState(false);
  const [locationData, setLocationData] = useState([
    {
      lat: "",
      lng: "",
      img: "",
      name: "",
    },
  ]);

  // doctor dropdown
  const [doctorDropdown, setDoctorDropdown] = useState({
    province_id: "",
    district_id: "",
    secretariats_id: "",
  });
  //   get search data
  const getSearchData = async (search) => {
    setSearchLoader(true);
    const url = `clinic/clinic_search`;
    await api.getAll(url, { ...searchTable, search: search }, (err, res) => {
      if (res?.data?.status === 200) {
        // console.log("Fetched Data:", res?.data?.data);
        const data = res?.data?.data;
        setSearchData(data); // Store data in state
      } else {
        console.error("Error fetching data:", err);
      }
      setSearchLoader(false);
    });
  };
  // call the api for area
  // for dropdown search
  const getSearchDataDropdown = async (selectedDropdown) => {
    setSearchLoaderDropdown(true);
    const url = `clinic/clinic_search`;
    await api.getAll(
      url,
      {
        province_id: selectedDropdown.province_id,
        secretariats_id: selectedDropdown.secretariats_id,
        district: selectedDropdown.district_id,
      },
      (err, res) => {
        if (res?.data?.status === 200) {
          // console.log("Fetched Data:", res?.data?.data);
          const data = res?.data?.data;
          setSearchData(data); // Store data in state
        } else {
          console.error("Error fetching data:", err);
        }
        setSearchLoaderDropdown(false);
      }
    );
  };
  const getAreaFilter = async () => {
    setAreaFilterLoader(true);
    const url = `clinic/area_filter_list`;
    await api.getAll(url, {}, (err, res) => {
      if (res?.data?.status === 200) {
        // console.log("Fetched Data:", res?.data?.data);
        const data = res?.data?.data;
        setAreaFilterData(data); // Store data in state
      } else {
        console.error("Error fetching data:", err);
      }
      setAreaFilterLoader(false);
    });
  };
  // add appointment form
  const addNewAppointment = async (data, navigate = null) => {
    setAddAppointmentFormLoader(true);
    await api.create("appointment/create_appointment", data, (err, res) => {
      if (res?.data?.status === 200) {
        // <Alert message="Form submitted successfully" type="success" />;
        message.success("Form submitted successfully");
        navigate && navigate("/thankyou");
        setAddAppointmentPopup(false);
        setClinicFormPopup(false);
        addAppointmentForm.resetFields();
      } else {
        // <Alert message="Form submission failed" type="error " />;
        message.error("Form submission failed");
      }
      setAddAppointmentFormLoader(false);
    });
  };
  // province dropdown
  const provinceDropdown = async (name) => {
    setProvinceLoaderDropdown(true);
    await api.getAll("clinic/province-dropdown", { name: name }, (err, res) => {
      if (res?.data?.status === 200) {
        setProvinceListDropdown(res?.data?.data);
      } else {
        setProvinceListDropdown([]);
      }
      setProvinceLoaderDropdown(false);
    });
  };
  // district dropdown
  const districtDropdown = async (id) => {
    if (!id) {
      setDistrictListDropdown([]);
    } else {
      setDistrictLoaderDropdown(true);
      await api.getAll(
        "clinic/district-dropdown",
        { province: id },
        (err, res) => {
          if (res?.data?.status === 200) {
            setDistrictListDropdown(res?.data?.data);
          } else {
            setDistrictListDropdown([]);
          }
          setDistrictLoaderDropdown(false);
        }
      );
    }
  };
  // secretariat dropdown
  const secretariatsDropdown = async (id) => {
    if (!id) {
      setSecretariatListDropdown([]);
    } else {
      setSecretariatLoaderDropdown(true);
      await api.getAll(
        "clinic/secretariats-dropdown",
        { district: id },
        (err, res) => {
          if (res?.data?.status === 200) {
            setSecretariatListDropdown(res?.data?.data);
          } else {
            setSecretariatListDropdown([]);
          }
          setSecretariatLoaderDropdown(false);
        }
      );
    }
  };
  // DOCTOR LIST
  const getDoctorSearchData = async () => {
    setDoctorSearchLoader(true);
    const url = `clinic/doctor_search`;
    await api.getAll(
      url,
      { ...doctorSearchTable, search: doctorSearchTable.search },
      (err, res) => {
        if (res?.data?.status === 200) {
          // console.log("Fetched Data:", res?.data?.data);
          const data = res?.data?.data;
          setDoctorSearchData(data); // Store data in state
        } else {
          console.error("Error fetching data:", err);
        }
        setDoctorSearchLoader(false);
      }
    );
  };
  // pinpoint
  const getPincodeData = async () => {
    setPincodeLoader(true);
    const url = `clinic/pinPoint`;
    await api.getAll(url, {}, (err, res) => {
      if (res?.data?.status === 200) {
        // console.log("Fetched Data:", res?.data?.data);
        const data = res?.data?.data;
        const locations = data.map((item) => ({
          lat: item.latitude,
          lng: item.longitude,
          img: item.logo_image,
          name: item.name,
        }));
        setLocationData(locations);
      } else {
        console.error("Error fetching data:", err);
      }
      setPincodeLoader(false);
    });
  };
  const getDoctorDataDropdown = async (doctorDropdown) => {
    setDoctorSearchLoader(true);
    const url = `clinic/doctor_search`;
    await api.getAll(
      url,
      {
        province: doctorDropdown.province_id,
        secretariats: doctorDropdown.secretariats_id,
        district: doctorDropdown.district_id,
      },
      (err, res) => {
        if (res?.data?.status === 200) {
          // console.log("Fetched Data:", res?.data?.data);
          const data = res?.data?.data;
          setDoctorSearchData(data); // Store data in state
        } else {
          console.error("Error fetching data:", err);
        }
        setDoctorSearchLoader(false);
      }
    );
  };
  const getSeoData = async () => {
    const url = `clinic/get-seo-data`;
    await api.getAll(url, {}, (err, res) => {
      if (res?.data?.status === 200) {
        console.log("Fetched Data:", res?.data?.data);
        const data = res?.data?.data;
        setSeoData(data);
      } else {
        console.error("Error fetching data:", err);
      }
    });
  };

  return (
    <Context.Provider
      value={{
        searchData,
        setSearchData,
        searchTable,
        setSearchTable,
        getSearchData,
        searchLoader,
        getAreaFilter,
        areaFilterData,
        areaFilterLoader,
        setAreaFilterLoader,
        areaFilterData,
        setAreaFilterData,
        // appointment form
        addAppointmentPopup,
        setAddAppointmentPopup,
        addAppointmentFormLoader,
        setAddAppointmentFormLoader,
        addNewAppointment,
        addAppointmentForm,
        clinicFormPopup,
        setClinicFormPopup,
        // province dropdown
        selectedDropdown,
        setSelectedDropdown,
        provinceDropdown,
        provinceLoaderDropdown,
        setProvinceLoaderDropdown,
        provinceListDropdown,
        setProvinceListDropdown,
        // district dropdown
        districtDropdown,
        districtListDropdown,
        setDistrictListDropdown,
        districtLoaderDropdown,
        setDistrictLoaderDropdown,
        // secretariat dropdown
        secretariatsDropdown,
        secretariatListDropdown,
        setSecretariatListDropdown,
        secretariatLoaderDropdown,
        setSecretariatLoaderDropdown,
        // drpdown reset
        getSearchDataDropdown,
        searchLoaderDropdown,
        // doctor list
        getDoctorSearchData,
        doctorSearchLoader,
        setDoctorSearchLoader,
        doctorSearchData,
        setDoctorSearchData,
        getPincodeData,
        pincodeLoader,
        setPincodeLoader,
        locationData,
        setLocationData,
        // doctor dropdown
        getDoctorDataDropdown,
        doctorDropdown,
        setDoctorDropdown,
        doctorSearchTable,
        setDoctorSearchTable,
        seoData,
        getSeoData,
        ...props, // Passing any additional props
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default SearchProvider;
